export default __webpack_public_path__ + "static/media/edit-icon.8b2a6f2f.svg";